var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaperCheckIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 77,
    viewBox: "0 0 76 77",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1469_6215",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 76,
    height: 77
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.5 1.25586V76.2559H0.5V1.25586H75.5Z",
    fill: "white",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1469_6215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.6543 9.90137C73.5985 10.8031 75.1524 14.5387 75.0112 19.0472C73.8811 36.8234 45.7695 49.0607 45.7695 65.9353C45.7695 70.4438 49.3011 74.8234 54.1041 75.7251C59.0483 76.6268 63.145 73.2777 63.4275 69.0268C63.5688 66.9658 62.8625 64.1319 62.8625 64.1319L52.5502 62.3285",
    stroke: "#D70064",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7458 1.78636L68.6565 9.90162C65.2662 9.25755 62.0171 11.0609 60.4632 13.5084C59.1918 15.4406 59.0506 17.8881 59.4744 19.305C59.4744 19.4338 59.3331 19.6914 59.1918 19.5626L14.4112 11.705C13.1398 9.12874 13.4224 6.03721 15.1175 4.36264C16.9539 2.55925 19.7792 1.27111 22.7458 1.78636Z",
    stroke: "#D70064",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0032 13.6377C18.7875 33.7326 0.988281 39.7868 0.988281 55.5021C0.988281 60.0106 3.38978 65.1631 9.46412 66.7089L28.8173 70.4445",
    stroke: "#D70064",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.214 31.0273L30.9352 43.2646L25.1434 38.1121L19.3516 43.2646L30.9352 53.8273L50.0058 36.3087L44.214 31.0273Z",
    stroke: "#D70064",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperCheckIcon);
export default __webpack_public_path__ + "static/media/paper-check-icon.ac180915.svg";
export { ForwardRef as ReactComponent };